import React from "react";
import PropTypes from "prop-types";

import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { grid } from "ionicons/icons";
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
);

function HorizontalStackBar({
  title,
  labels,
  data,
}) {
  const rawValues = data.map((item) => item.value);
  const total = rawValues.reduce((a, b) => a + b, 0);
  const normalized = rawValues.map((v) => (v / total) * 100);
  const datasets = data.map((item, index) => ({
    label: item.label,
    data: [normalized[index]],
    backgroundColor: item.backgroundColor,
    stack: "Stack 0",
    barThickness: 20, // Altezza barra
  }));

  return (
    <Bar
      height={10}
      data={{
        labels,
        datasets,
      }}
      options={{
        indexAxis: "y",
        responsive: true,
        maintainAspectRatio: false,
        elements: {
          bar: {
            barThickness: 20, // Altezza barra
          },
        },
        scales: {
          x: {
            stacked: true,
            display: false,
          },
          y: {
            stacked: true,
            display: false,
          },
        },
        plugins: {
          title: {
            display: title ? true : false,
            text: title,
          },
          legend: {
            position: "bottom",
          },
          tooltip: {
            callbacks: {
              label: function (context) {
                const label = context.dataset.label || '';
                const value = context.raw;
                return `${label}: ${value.toFixed(1)}%`;
              },
            },
          },
        },
      }}
    />
  );
}

export default HorizontalStackBar;

HorizontalStackBar.propTypes = {
  data: PropTypes.arrayOf({
    label: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    backgroundColor: PropTypes.string.isRequired,
  }).isRequired,
};
